import { Box } from '@mui/material';
import { useAccount } from '../contexts/Account';
import Treatment from '../components/Treatment';
import { featureFlags } from '../splitSetup';

function CustomIFrameScene({ url, title }) {
  const { isFreeTrial, currentPlan } = useAccount();
  const mobileTop = isFreeTrial
    ? '126px'
    : currentPlan.specialOffersUrl
    ? '124px'
    : '66px';
  const desktopTop = isFreeTrial
    ? '126px'
    : currentPlan.specialOffersUrl
    ? '100px'
    : '66px';

  return (
    <Treatment
      splitNames={featureFlags.bottom_navigation}
      evaluatedComponent={
        <Box
          sx={{
            position: 'fixed',
            top: { xxs: mobileTop, sm: desktopTop },
            left: 0,
            right: 0,
            bottom: '64px',
            '@media (min-width: 800px)': {
              bottom: '0px',
            },
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            touchAction: 'pan-y',
            overscrollBehavior: 'contain',
          }}
        >
          <iframe
            src={url}
            title={title || 'Custom IFrame'}
            scrolling="yes"
            style={{
              border: 'none',
              width: '100%',
              height: '100%',
              display: 'block',
              touchAction: 'pan-y',
              WebkitOverflowScrolling: 'touch',
            }}
          />
        </Box>
      }
      conditionFailedComponent={
        <Box
          sx={{
            position: 'fixed',
            top: { xxs: mobileTop, sm: desktopTop },
            left: 0,
            right: 0,
            bottom: 0,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            touchAction: 'pan-y',
            overscrollBehavior: 'contain',
          }}
        >
          <iframe
            src={url}
            title={title || 'Custom IFrame'}
            scrolling="yes"
            style={{
              border: 'none',
              width: '100%',
              height: '100%',
              display: 'block',
              touchAction: 'pan-y',
              WebkitOverflowScrolling: 'touch',
            }}
          />
        </Box>
      }
    />
  );
}

export default CustomIFrameScene;
